import {InitPage} from "../index";

class MfBinManagement {
    constructor() {
        $('#export-btn').on('click', function () {
            $('.exportCSV').modal('show');
        });

        $('#customer').on('change', function () {
            const url = new URL(window.location.href);
            url.searchParams.set('customer_id', $('#customer').val().toString());
            window.location.href = url.href;
        });

        $('#customer_location').on('change', function () {
            const url = new URL(window.location.href);
            url.searchParams.set('customer_location_id', $('#customer_location').val().toString());
            window.location.href = url.href;
        });

        $('.details').on('click', function () {
            const id = $(this).attr('data-id');
            const status = $(this).hasClass('fa-chevron-down');
            if (status) {
                $(this).removeClass('fa-chevron-down');
                $(this).addClass('fa-chevron-up');
                $('#bin-details-' + id).show();
            } else {
                $(this).removeClass('fa-chevron-up');
                $(this).addClass('fa-chevron-down');
                $('#bin-details-' + id).hide();
            }
        })
    }
}

export function LoadPage() {
    InitPage("bin_managements index", () => {
        const c = new MfBinManagement();
    });
}
